var searchHeader = vueIfExists({
    mixins: [win.buttonSpinner, win.availCheckMixin],
	el: '#search-header',
	data: {
		sharedState: store.state,
        headerImageSrc: '',
	},

    mounted: function() {
        if (this.sharedState.query.start && this.sharedState.query.end) {
            var result = win.calendar.validateDates(this.sharedState.query.start, this.sharedState.query.end );
            if (!result.valid) {
                this.sharedState.errorType = result.errorType;
            }
        } 
        
        if (!win.isMobile) {
            var headerImages = dataLayer[0].objHeaderImages || [];
                images = headerImages.city || headerImages.region || headerImages.country || [];
            if (images.length) {
                this.headerImageSrc = images[Math.floor(Math.random() * images.length) ]; 
            } else {
                this.headerImageSrc = '../images/bg/us-header_19969.jpg';
            }
            if (win.canUseWebP()) {
                this.headerImageSrc = this.headerImageSrc.replace(/\.jpg$/, '.webp');
            }
        }

    }
});

